module.exports = __webpack_public_path__ + "static/media/Ali2.8701e757.svg";